import { render, staticRenderFns } from "./Portal.vue?vue&type=template&id=347c1fec&scoped=true&"
import script from "./Portal.vue?vue&type=script&lang=js&"
export * from "./Portal.vue?vue&type=script&lang=js&"
import style0 from "./Portal.vue?vue&type=style&index=0&id=347c1fec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347c1fec",
  null
  
)

export default component.exports